export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"robots","content":"index, follow, max-image-preview:large, max-snippet:-1"},{"name":"p:domain_verify","content":"6a492b476ce81e9c38c7239bdadc555e"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/favicon.ico","media":"(prefers-color-scheme: light)"},{"rel":"icon","type":"image/x-icon","href":"/favicon-light.ico","media":"(prefers-color-scheme: dark)"},{"rel":"stylesheet preload","as":"style","href":"https://fonts.googleapis.com/css2?family=Be+Vietnam+Pro:wght@400;500;600;700;900&display=swap","type":"text/css","crossorigin":"anonymous"},{"rel":"preload","as":"font","type":"font/woff2","href":"https://fonts.gstatic.com/s/bevietnampro/v11/QdVPSTAyLFyeg_IDWvOJmVES_Hw3BXoYZ7Aj.woff2","crossorigin":"anonymous"},{"rel":"preload","as":"font","type":"font/woff2","href":"https://fonts.gstatic.com/s/bevietnampro/v11/QdVMSTAyLFyeg_IDWvOJmVES_HTEJm86Rb0JcBaoUUU.woff2","crossorigin":"anonymous"},{"rel":"preload","as":"font","type":"font/woff2","href":"https://fonts.gstatic.com/s/bevietnampro/v11/QdVPSTAyLFyeg_IDWvOJmVES_Hw5BXoYZ7AjSh8.woff2","crossorigin":"anonymous"},{"rel":"preload","as":"font","type":"font/woff2","href":"https://fonts.gstatic.com/s/bevietnampro/v11/QdVPSTAyLFyeg_IDWvOJmVES_Hw4BXoYZ7AjSh8.woff2","crossorigin":"anonymous"},{"rel":"preload","as":"font","type":"font/woff2","href":"https://fonts.gstatic.com/s/bevietnampro/v11/QdVMSTAyLFyeg_IDWvOJmVES_HTEJm81Rb0JcBao.woff2","crossorigin":"anonymous"},{"rel":"preload","as":"font","type":"font/woff2","href":"https://fonts.gstatic.com/s/bevietnampro/v11/QdVMSTAyLFyeg_IDWvOJmVES_HSMIG81Rb0JcBao.woff2","crossorigin":"anonymous"},{"rel":"preload","as":"font","type":"font/woff2","href":"https://fonts.gstatic.com/s/bevietnampro/v11/QdVMSTAyLFyeg_IDWvOJmVES_HSMIG87Rb0JcBaoUUU.woff2","crossorigin":"anonymous"},{"rel":"preload","as":"font","type":"font/woff2","href":"https://fonts.gstatic.com/s/bevietnampro/v11/QdVMSTAyLFyeg_IDWvOJmVES_HSMIG86Rb0JcBaoUUU.woff2","crossorigin":"anonymous"},{"rel":"preload","as":"font","type":"font/woff2","href":"https://fonts.gstatic.com/s/bevietnampro/v11/QdVMSTAyLFyeg_IDWvOJmVES_HToIW81Rb0JcBao.woff2","crossorigin":"anonymous"},{"rel":"preload","as":"font","type":"font/woff2","href":"https://fonts.gstatic.com/s/bevietnampro/v11/QdVMSTAyLFyeg_IDWvOJmVES_HToIW87Rb0JcBaoUUU.woff2","crossorigin":"anonymous"},{"rel":"preload","as":"font","type":"font/woff2","href":"https://fonts.gstatic.com/s/bevietnampro/v11/QdVMSTAyLFyeg_IDWvOJmVES_HToIW86Rb0JcBaoUUU.woff2","crossorigin":"anonymous"},{"rel":"preload","as":"font","type":"font/woff2","href":"https://fonts.gstatic.com/s/bevietnampro/v11/QdVMSTAyLFyeg_IDWvOJmVES_HTEJm87Rb0JcBaoUUU.woff2","crossorigin":"anonymous"}],"style":[],"script":[{"src":"https://www.amcharts.com/lib/4/core.js"},{"src":"https://www.amcharts.com/lib/4/maps.js"},{"src":"https://www.amcharts.com/lib/4/geodata/worldLow.js"},{"src":"https://unpkg.com/vue"},{"src":"./dist/vue-phone-number-input.umd.min.js"}],"noscript":[],"htmlAttrs":{"lang":"vi"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = false

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink"}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000